module.exports = "/_next/static/images/2aefbbfdfc710a0a881f74c8e2300b7e-kaszek.png.webp";